export type OrderBundleModel = {
  id: number,
  assigned_price_list_ids?: number[],
  assigned_provider_ids?: number[],
  assigned_publication_ids?: number[],
  assigned_service_product_ids?: number[],
  cache_key: number,
  end_date?: any,
  global?: boolean,
  hidden?: boolean,
  price: number,
  product_code?: string,
  product_name?: string,
  start_date?: any,
  title: string,
}

const state = {
  id: null,
  end_date: '',
  global: false,
  hidden: false,
  price: '',
  product_code: '',
  product_name: '',
  start_date: '',
  title: '',
}

export const requiredFields = [
  { key: 'price' },
  { key: 'title' },
]

export default state
